@if (content) {
  <div id="additionalinfo">
    <h2 data-cy="additionalInfoHeader" class="heading__text--medium" [innerHTML]="heading"></h2>
    @for (links of content.additionalInfoLinks; track links) {
      <div data-cy="additionalInfoLinks">
        <a c11n-link variant="primary-independent" iconName="pop-window" class="c11n-text-md rmd-text"
        href="{{ links.link }}" target="_blank" aria-describedby="link-new-window">{{ links.label }}</a>
      </div>
    }
    <span hidden id="link-new-window">{{ content.additionalInfoLinkAriaLabel }}</span>
  </div>
}
